<div class="rest_dra">
  <div class="frm_date_dra">
    <div
      class="page-title-bar flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start"
    >
      <div
        class="title d-flex justify-content-between align-items-center w-100"
      >
        <div class="d-flex align-items-center">
          <button mat-icon-button (click)="navigate()" class="me-3">
            <mat-icon class="material-icons-round">arrow_back</mat-icon>
          </button>
          <div>
            <h1 class="mb-0">All bookings</h1>
            <h2 class="m-0" *ngIf="pageSubTitle">{{ pageSubTitle }}</h2>
          </div>
        </div>
        <div class="d-flex align-items-center ms-auto">
          <button
            mat-icon-button
            class="Create_header_btn"
            color="primary"
            [matMenuTriggerFor]="menu"
            aria-label="Add new booking"
            *ngIf="isAccessForEmployeeInvoice"
          >
            <mat-icon>add</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="createNewBooking()">
            <mat-icon class="material-icons-outlined">event</mat-icon>
            <span>New booking</span>
          </button>
          <button mat-menu-item (click)="addNewInterestFromList()">
            <mat-icon class="material-icons-outlined"
              >card_membership</mat-icon
            >
            <span>New membership request</span>
          </button>
        </mat-menu>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>
      <button *ngIf="showButton" mat-button>{{ showButton }}</button>
      <div class="date-range-form">
        <div class="nw_all">
          <mat-form-field appearance="outline" (click)="fromDatePicker.open()">
            <mat-label>From Date</mat-label>
            <input
              matInput
              [matDatepicker]="fromDatePicker"
              [(ngModel)]="fromDate"
              readonly
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="fromDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #fromDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="nw_all">
          <mat-form-field appearance="outline" (click)="toDatePicker.open()">
            <mat-label>To Date</mat-label>
            <input
              matInput
              [matDatepicker]="toDatePicker"
              [(ngModel)]="toDate"
              readonly
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="toDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="search_pag">
          <button
            (click)="search()"
            mat-flat-button
            color="primary"
            type="submit"
          >
            {{ "booking_history.search" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="chip_cont">
  <div class="booing_sectyy">
    <div class="booing_sectyy">
      <mat-chip-listbox aria-label="Fish selection" class="mb-3">
        <mat-chip
          (click)="changeChip('1')"
          [ngClass]="{ 'Graceful-box-active': selectedValue == '1' }"
          >Bookings
        </mat-chip>
      </mat-chip-listbox>
      <mat-chip-listbox aria-label="Fish selection" class="mb-3">
        <mat-chip
          (click)="changeChip('2')"
          [ngClass]="{ 'Graceful-box-active': selectedValue == '2' }"
          >Membership request
        </mat-chip>
      </mat-chip-listbox>
      <mat-chip-listbox aria-label="Fish selection" class="mb-1">
        <mat-chip
          (click)="changeChip('3')"
          [ngClass]="{ 'Graceful-box-active': selectedValue == '3' }"
          >Customer queries
        </mat-chip>
      </mat-chip-listbox>
    </div>
  </div>
</div>

<div class="" *ngIf="!loader && selectedValue == '1'">
  <div class="row">
    <div class="col-sm-4" *ngFor="let data of messageList">
      <div
        class="plan-card"
        style="position: relative"
        (click)="bookingDetails(data)"
      >
        <!-- <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
        style="position: absolute; right: 15px; top: 25px;z-index: 99;">
        <mat-icon>more_vert</mat-icon>
      </button> -->
        <mat-menu #menu2="matMenu">
          <!-- <button mat-menu-item (click)="confirmBooking(data)"
          *ngIf="(((data.bookingStatus == 0 || data.bookingStatus == 1 || data.bookingStatus == 2) && (data.customerInfo.hash_id && data.customerInfo.hash_id != 'null')) && (data.toshowOptions == 1))">
          <mat-icon class="material-icons-outlined">check_circle</mat-icon>
          <span>Confirm booking</span>
        </button> -->
          <button mat-menu-item (click)="bookingDetails(data)">
            <mat-icon class="material-icons-outlined">info</mat-icon>
            <span>Booking details</span>
          </button>
          <!-- <button mat-menu-item *ngIf="data.bookingStatus == 4" (click)="openInvoice(data)">
          <mat-icon class="material-icons-outlined">badge</mat-icon>
          <span>Invoice</span>
        </button>
        <button mat-menu-item (click)="cancelBooking(data)"
          *ngIf="(((data.bookingStatus == 0 || data.bookingStatus == 1 || data.bookingStatus == 2 || data.bookingStatus == 5)) && (data.toshowOptions == 1 && isOwner))">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>Cancel booking</span>
        </button>
        <button mat-menu-item *ngIf="(!data.customerInfo.hash_id || data.customerInfo.hash_id == 'null') && isOwner"
          (click)="deleteBooking(data)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span>Delete booking</span>
        </button> -->
        </mat-menu>
        <div class="d-flex align-items-center" style="position: relative">
          <!-- <div class="" style="width: 80px; height: 80px; max-width: 80px; max-height: 80px; position: relative">
          <img [src]="data.customer_thumb_image != null 
            && data.customer_thumb_image != 'null'
            && data.customer_thumb_image != '' ? data.customer_thumb_image : './assets/images/booking-history-1.jpg'" alt=""
            class="img-fluid rounded-circle"
            style="width:100%; height: 100%; object-fit: cover; object-position: center;">
        </div> -->
          <mat-icon
            *ngIf="
              !data.customerInfo.imgThumbUrl ||
              data.customerInfo.imgThumbUrl == 'null'
            "
            [class.new-booking]="
              data.bookingStatus == 0 ||
              data.bookingStatus == 1 ||
              data.bookingStatus == 2
            "
            [class.under-process]="
              data.bookingStatus == 3 ||
              data.bookingStatus == 7 ||
              data.bookingStatus == 9
            "
            [class.completed]="data.bookingStatus == 4"
            [class.cancelled]="
              data.bookingStatus == 6 || data.bookingStatus == 8
            "
            [class.confirmed]="data.bookingStatus == 5"
            class="status-icon"
          ></mat-icon>
          <mat-icon
            *ngIf="
              data.customerInfo.imgThumbUrl &&
              data.customerInfo.imgThumbUrl != 'null'
            "
            [class.new-booking]="
              data.bookingStatus == 0 ||
              data.bookingStatus == 1 ||
              data.bookingStatus == 2
            "
            [class.under-process]="
              data.bookingStatus == 3 ||
              data.bookingStatus == 7 ||
              data.bookingStatus == 9
            "
            [class.completed]="data.bookingStatus == 4"
            [class.cancelled]="
              data.bookingStatus == 6 || data.bookingStatus == 8
            "
            [class.confirmed]="data.bookingStatus == 5"
            class="status-icon"
          ></mat-icon>
          <div
            class="booking-initial"
            *ngIf="
              !data.customerInfo.imgThumbUrl ||
              data.customerInfo.imgThumbUrl == 'null'
            "
          >
            {{ data.customerName.slice(0, 1).toUpperCase() }}
          </div>
          <img
            class="booking-initial-img img-fluid rounded-circle"
            [src]="data.customerInfo.imgThumbUrl"
            alt=""
            *ngIf="
              data.customerInfo.imgThumbUrl &&
              data.customerInfo.imgThumbUrl != 'null'
            "
            onerror="this.src='../../../../assets/images/user-avatar.svg'"
          />
          <div class="m-2">
            <h2 class="plan-title">{{ data.customerName }}</h2>
            <p class="booking-number">
              <span class="bookingstar"
                >{{ data.bookingStartTime }} - {{ data.bookingEndTime }},</span
              >
              <span *ngIf="data.appointment_no"
                >#{{ data.appointment_no }}</span
              >
            </p>

            <p class="plan-cost">
              <span class="value">{{ data.u_booking_date }}</span>
            </p>
          </div>
        </div>
        <p class="plan-cost">
          <span class="addign">Assigned to: </span>
          <span class="addign">{{
            data.employeeName ? data.employeeName : "---"
          }}</span>
        </p>
         <p class="plan-info">
          <span class="date_booking">Service mode: {{ data.booking_type }}</span>
        </p>
        <p class="plan-info">
          <span class="label">Status: </span>
          <span class="value">{{ data.bookingStat }}</span>
          <span
            class="label"
            *ngIf="data.paymentStat && data.paymentStat != '---'"
            >, Payment:
          </span>
          <span
            class="value"
            *ngIf="data.paymentStat && data.paymentStat != '---'"
            >{{ data.paymentStat }}</span
          >
        </p>
        <p class="plan-info">
          <span class="date_booking">{{ data.bookingDate | date }}</span>
        </p>
        <div class="arrow_iocn_x">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- placeholder html start -->
<div
  class="placeholder_started"
  *ngIf="visible && messageList.length == 0 && selectedValue == '1'"
>
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/booking-history-1.jpg" />
            </div>
            <mat-card-title>No booking to show.</mat-card-title>
            <mat-card-content
              >All the bookings will appear here between the selected date
              range. It seems you haven't started operations or check the
              selected dates.
            </mat-card-content>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="/assets/images/new-booking.png" />
            </div>
            <mat-card-title>How to create a new booking?</mat-card-title>
            <mat-card-content
              >Check our
              <span
                class="ghtunderline"
                (click)="openLink('https://lookzup.com/help')"
              >
                help document
              </span>
              on creating new booking against a business. You can check this
              video as well.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>play_arrow</mat-icon>
                Watch video
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png" />
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content
              >For any difficulties in getting the list of bookings or issue
              with managing them, contact our support team.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button
                mat-stroked-button
                color="primary"
                (click)="opencontact()"
              >
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<!-- placeholder html end -->

<!-- MEMBERSHIP QUERIES START -->
<div
  class="busroy"
  *ngIf="!loader && interestData.length > 0 && selectedValue == '2'"
>
  <div class="row">
    <div
      class="col-sm-4"
      *ngFor="let item of interestData"
      (click)="viewDetails(item)"
    >
      <mat-card>
        <div class="booking-card">
          <div class="booking-header">
            <div class="left-section" style="position: relative">
              <mat-icon
                [class.new-booking]="item.enrollment_request_status == 1"
                [class.under-process]="item.enrollment_request_status == 2"
                [class.completed]="item.enrollment_request_status == 5"
                [class.cancelled]="item.enrollment_request_status == 4"
                [class.confirmed]="item.enrollment_request_status == 3"
                class="status-icon memht"
              ></mat-icon>
              <div
                class="booking-initial"
                *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'"
              >
                {{ item.customer_name.slice(0, 1) }}
              </div>
              <img
                class="booking-initial-img img-fluid rounded-circle"
                [src]="item.image_thumb_url"
                alt=""
                *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'"
                onerror="this.src='../../../../assets/images/user-avatar.svg'"
              />
              <div class="booking-details">
                <h3 class="booking-name">{{ item.customer_name }}</h3>
                <p class="booking-number">
                  <span
                    class="bookingstar"
                    style="font-size: 14px; color: #888"
                    >{{ item.phone }}</span
                  >
                </p>
              </div>
            </div>

            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button> -->
          </div>

          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Status: </span>
            <span class="value">{{ item.item_status }}</span>
          </p>
          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Service mode: </span>
            <span class="value">{{ item.service_mode }}</span>
          </p>
          <p class="booking-meta">
            <span class="label">Services: </span>
            <span class="value">{{ item.opted_services }} </span>
            <!-- <span class="value">{{item.bookingStartTime}} - {{item.bookingEndTime}}</span>  -->
          </p>
          <p class="booking-meta">
            <span class="value">{{ item.creation_time | date }}</span>
          </p>
        </div>
        <div class="arrow_iocn_x">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<!-- placeholder html start -->
<div
  class="placeholder_started"
  *ngIf="!loader && interestData.length == 0 && selectedValue == '2'"
>
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/query-s1.jpg" />
            </div>
            <mat-card-title>No queries to show.</mat-card-title>
            <mat-card-content
              >All the queries will appear here between the selected date range.
              It seems you haven't started operations or check the selected
              dates.
            </mat-card-content>
            <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
          </div>
        </mat-card>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="/assets/images/new-booking.png" />
            </div>
            <mat-card-title>How to create a new query?</mat-card-title>
            <mat-card-content
              >Check our
              <span
                class="ghtunderline"
                (click)="openLink('https://lookzup.com/help')"
              >
                help document
              </span>
              on creating new query against a business. You can check this video
              as well.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>play_arrow</mat-icon>
                Watch video
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png" />
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content
              >For any difficulties in adding a new query or issue with managing
              them, contact our support team.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button
                mat-stroked-button
                color="primary"
                (click)="opencontact()"
              >
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<!-- placeholder html end -->

<!-- MEMBERSHIP QUERIES END -->

<!-- QUERIES START -->
<div
  class="busroy"
  *ngIf="visible && !loader && queryData.length > 0 && selectedValue == '3'"
>
  <div class="row">
    <div
      class="col-sm-4"
      *ngFor="let item of queryData"
      (click)="viewDetailsforservicequery(item)"
    >
      <mat-card>
        <div class="booking-card">
          <div class="booking-header">
            <div class="left-section" style="position: relative">
              <mat-icon
                [class.new-booking]="item.status == 1"
                [class.under-process]="item.status == 2"
                [class.completed]="item.status == 3"
                class="status-icon memht"
              ></mat-icon>
              <div
                class="booking-initial"
                
              >
                {{ item.name.slice(0, 1) }}
              </div>
              <!-- <img
                class="booking-initial-img img-fluid rounded-circle"
                [src]="item.image_thumb_url"
                alt=""
                *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'"
                onerror="this.src='../../../../assets/images/user-avatar.svg'"
              /> -->
              <div class="booking-details">
                <h3 class="booking-name">{{ item.name }}</h3>
                <p class="booking-number">
                  <span
                    class="bookingstar"
                    style="font-size: 14px; color: #888"
                    >{{ item.phone }}</span
                  >
                </p>
              </div>
            </div>

            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button> -->
          </div>

          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Status: </span>
            <span class="value">{{ item.item_status }}</span>
          </p>
          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Service mode: </span>
            <span class="value">{{ item.s_mode }}</span>
          </p>
         
          <p class="booking-meta">
            <span class="value">{{ item.creation_time | date : 'MMM d, y, h:mm a' : 'UTC' }}</span>
          </p>
        </div>
        <div class="arrow_iocn_x">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<!-- placeholder html start -->
<div
  class="placeholder_started"
  *ngIf="visible && !loader && queryData.length == 0  && selectedValue == '3'"
>
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/query-s1.jpg" />
            </div>
            <mat-card-title>No service queries to show.</mat-card-title>
            <mat-card-content
              >All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
            </mat-card-content>
            <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
          </div>
        </mat-card>
      </div>
    </div>
<!-- 
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="/assets/images/new-booking.png" />
            </div>
            <mat-card-title>How to create a new query?</mat-card-title>
            <mat-card-content
              >Check our
              <span
                class="ghtunderline"
                (click)="openLink('https://lookzup.com/help')"
              >
                help document
              </span>
              on creating new query against a business. You can check this video
              as well.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>play_arrow</mat-icon>
                Watch video
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div> -->
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png" />
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content
              >For any difficulties contact our support team.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button
                mat-stroked-button
                color="primary"
                (click)="opencontact()"
              >
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<!-- placeholder html end -->

<!-- QUERIES END -->
